import { type FC, type PropsWithChildren, type ReactElement } from "react";

export const COLUMN_SELECTION_BUTTON_PLACEHOLDER_ID = "column-selection-button-placeholder";
export const COLUMN_SELECTION_GUIDANCE_TIMER = 5000;

const ColumnSelectionButton: FC<PropsWithChildren<{ portalContext?: string }>> = (props): ReactElement => {
  const portalContext: string = props.portalContext || "";
  return (
    <span
      key={COLUMN_SELECTION_BUTTON_PLACEHOLDER_ID + portalContext}
      id={COLUMN_SELECTION_BUTTON_PLACEHOLDER_ID + portalContext}
    />
  );
};

export default ColumnSelectionButton;
